import React, { useState } from 'react';
import { Shield, Lock, ShieldAlert } from 'lucide-react';
import './Login.css';

export default function Login({ onLoginSuccess }) {
    const [username, setUsername] = useState('admin');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const res = await fetch('/api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password })
            });
            const data = await res.json();

            if (!res.ok) {
                setError(data.error || 'Authentication failed');
            } else {
                onLoginSuccess();
            }
        } catch (err) {
            setError('Network error. Unable to reach authentication server.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="shield-icon-container">
                        <Shield size={48} className="shield-icon" />
                    </div>
                    <h1>SEO Central</h1>
                    <p>Secure Access Gateway</p>
                </div>

                {error && (
                    <div className="login-error">
                        <ShieldAlert size={16} />
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="input-group">
                        <label>Email / Username</label>
                        <input
                            type="text"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                            disabled={loading}
                            className="cyber-input"
                        />
                    </div>

                    <div className="input-group">
                        <label>Master Password</label>
                        <div className="password-wrapper">
                            <Lock size={16} className="input-icon" />
                            <input
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                                disabled={loading}
                                className="cyber-input with-icon"
                                placeholder="••••••••"
                            />
                        </div>
                    </div>

                    <button type="submit" disabled={loading} className="cyber-button">
                        {loading ? 'Authenticating...' : 'INITIALIZE UPLINK'}
                    </button>
                </form>
            </div>

            <div className="cyber-grid-overlay"></div>
        </div>
    );
}
